import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { IdentifySurroundingFeatureParam } from '../state-management';
import { ConfigService } from './config.service';


const httpOptions = {
  headers: new HttpHeaders({
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache'
  })
};

@Injectable()
export class FeaturesService {
  featuresUrl = 'api/';
  headers: any;
  error: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService
  ) {
  }

  identifySurroundingFeature(url: string): Observable<any> {
    return this.httpClient.get<any>(url, this.httpOptions);
  }
  identifySurroundingFeaturePost(params: IdentifySurroundingFeatureParam): Observable<any> {
    return this.httpClient.post<any>(this.configService.webApiEndpoint + 'identifyFeaturesPost', params, this.httpOptions);
  }

  getGisFeatureData(url: string): Observable<any> {
    return this.httpClient.get<any>(url, this.httpOptions);
  }

  getFlowWorksData(url: string) {
    return this.httpClient.get(url);
  }
}
